var name = "roboflow-staging";
var env = "staging";
var emulated;
const _ = require("lodash");

// Environment configs - plain JS modules work in both Node.js and webpack
const environmentConfigs = {
    "roboflow-staging": require("../environments/roboflow-staging.js"),
    "roboflow-platform": require("../environments/roboflow-platform.js"),
    "roboflow-eu-staging": require("../environments/roboflow-eu-staging.js"),
    "roboflow-eu-platform": require("../environments/roboflow-eu-platform.js")
};

const allRoboflowDomains = Object.values(environmentConfigs).map((c) => c.urlDomain);

function checkGACSync() {
    if (typeof process == "undefined" || process.browser || emulated) {
        return true;
    }
    if (process.env.GOOGLE_APPLICATION_CREDENTIALS) {
        if (!process.env.GAC_PROJECT) {
            console.log(
                "Environment variable GOOGLE_ACCOUNT_CREDENTIALS is set, but was not set with secrets.sh. Please use secrets.sh gac to set it instead, exiting."
            );
            process.exit(1);
        }

        if (process.env.GCLOUD_PROJECT) {
            if (process.env.GCLOUD_PROJECT !== process.env.GAC_PROJECT) {
                console.log(
                    "Environment variable GCLOUD_PROJECT does not match the project set in secrets.sh, exiting.",
                    process.env.GCLOUD_PROJECT,
                    process.env.GAC_PROJECT,
                    process.env.GOOGLE_APPLICATON_CREDENTIALS
                );
                process.exit(1);
            }
        }

        if (name !== process.env.GAC_PROJECT) {
            console.log(
                "projectSelector is using a project name that is not in sync with what secrets.sh used, exiting.",
                name,
                process.env.GAC_PROJECT
            );
            process.exit(1);
        }
    }
}

if (typeof process != "undefined" && !process.browser) {
    emulated = !!process.env.FUNCTIONS_EMULATOR;

    if (!emulated && process.env.GCLOUD_PROJECT == "roboflow-platform") {
        name = "roboflow-platform";
        env = "prod";
    } else if (!emulated && process.env.GCLOUD_PROJECT == "roboflow-eu-platform") {
        name = "roboflow-eu-platform";
        env = "eu-prod";
    } else if (!emulated && process.env.GCLOUD_PROJECT == "roboflow-eu-staging") {
        name = "roboflow-eu-staging";
        env = "eu-staging";
    }
} else {
    // Check if running on local development subdomains
    const localSubdomains = [
        "localhost",
        "localhost.roboflow.com",
        "localhost.staging.roboflow.com",
        "localhost.roboflow.one",
        "localapp.roboflow.one",
        "localapi.roboflow.one",
        "localuniverse.roboflow.one",
        "localrapid.roboflow.one",
        "localadmin.roboflow.one",
        "localdemo.roboflow.one",
        "localreferrals.roboflow.one",
        "rapid-localhost.roboflow.one"
    ];

    emulated = localSubdomains.includes(window.location.hostname);

    if (
        window.location.hostname == "app.roboflow.com" ||
        window.location.hostname == "public.roboflow.com" ||
        window.location.hostname == "public2.roboflow.com" ||
        window.location.hostname == "admin.roboflow.com" ||
        window.location.hostname == "models.roboflow.com" ||
        window.location.hostname == "universe.roboflow.com" ||
        window.location.hostname == "rapid.roboflow.com" ||
        window.location.hostname == "johndeere.roboflow.com" ||
        window.location.hostname == "johndeere-dev.roboflow.com" ||
        window.location.hostname == "bnsf.roboflow.com" ||
        window.location.hostname == "pella.roboflow.com" ||
        window.location.hostname == "ussvision.roboflow.com" ||
        window.location.hostname == "ussteel.roboflow.com" ||
        window.location.hostname == "simplot.roboflow.com" ||
        window.location.hostname == "ripcord.roboflow.com" ||
        window.location.hostname == "degould.roboflow.com" ||
        window.location.hostname == "oc.roboflow.com" ||
        window.location.hostname == "cummins.roboflow.com" ||
        window.location.hostname == "stackct.roboflow.com" ||
        window.location.hostname == "gevernova.roboflow.com"
    ) {
        name = "roboflow-platform";
        env = "prod";
    }

    if (window.location.hostname.endsWith(".roboflow.com")) {
        name = "roboflow-platform";
        env = "prod";
    }

    if (window.location.hostname.endsWith(".roboflow.eu")) {
        name = "roboflow-eu-platform";
        env = "eu-prod";
    }

    if (window.location.hostname.endsWith(".roboflow-eu.one")) {
        name = "roboflow-eu-staging";
        env = "eu-staging";
    }
}

if (global.FORCE_PROD) {
    name = "roboflow-platform";
    env = "prod";
}

if (global.FORCE_STAGING) {
    name = "roboflow-staging";
    env = "staging";
}
checkGACSync();

const project = {
    isLocal: function () {
        return emulated;
    },
    sessionCookieName: function () {
        return project.isLocal() ? "__session_local" : "__session";
    },
    env: function () {
        return env;
    },
    envTier: function () {
        const config = this.getEnvironmentConfig();
        return config.env;
    },
    region: function () {
        const config = this.getEnvironmentConfig();
        return config.region;
    },
    name: function () {
        return name;
    },
    release: function () {
        return process.env.K_VERSION || "Unknown";
    },
    isSSODomain: function () {
        const hostname = window.location?.hostname;
        const forbiddenDomains = [
            "universe.roboflow.com",
            "universe.roboflow.one",
            "public.roboflow.com",
            "public.roboflow.one",
            "models.roboflow.com",
            "models.roboflow.one",
            "admin.roboflow.com",
            "admin.roboflow.one"
        ];
        if (forbiddenDomains.includes(hostname)) {
            throw new Error(`You shouldnt be using isSSODomain() in this ${hostname} domain`);
        }
        const defaultDomains = [
            "localhost.roboflow.one",
            "localapp.roboflow.one",
            "app.roboflow.one",
            "app.roboflow.com",
            "app.roboflow-eu.one",
            "localhost.roboflow-eu.one",
            "localrapid.roboflow.one",
            "rapid-localhost.roboflow.one"
        ];
        return !defaultDomains.includes(hostname);
    },
    cookieDomain: function () {
        const config = this.getEnvironmentConfig();
        return config.cookieDomain;
    },
    appUrl: function (hash, full) {
        if (emulated && hash) return "https://localhost:5000/#app";
        if (emulated && !full) return "https://localapp.roboflow.one";
        const config = this.getEnvironmentConfig();
        return config.urls.app;
    },
    trainAppUrl: function () {
        const config = this.getEnvironmentConfig();
        return config.urls.app;
    },
    dataUrl: function () {
        const config = this.getEnvironmentConfig();
        return config.urls.public;
    },
    universeUrl: function (hash, full) {
        if (emulated && hash) return "https://localuniverse.roboflow.one/#universe";
        if (emulated && !full) return "https://localuniverse.roboflow.one";
        const config = this.getEnvironmentConfig();
        return config.urls.universe;
    },
    rapidUrl: function (hash, full) {
        if (emulated && hash) return "https://localrapid.roboflow.one/#rapid";
        if (emulated && !full) return "https://localrapid.roboflow.one";
        const config = this.getEnvironmentConfig();
        return config.urls.rapid;
    },
    rapidStreamApiUrl: function () {
        // Firebase hosting buffers the response on staging/prod.
        // We need to call the cloud function directly to enable streaming responses.
        if (emulated) {
            return "https://localrapid.roboflow.one";
        }
        const config = this.getEnvironmentConfig();
        return config.urls.rapidStreamApi;
    },
    universeRateLimitBypassKey: function () {
        return "jojofromroro";
    },
    dataCacheUrl: function (force) {
        if (emulated && !force) return "";
        if (emulated) return "http://localhost:5000";
        const config = this.getEnvironmentConfig();
        return config.urls.public2;
    },
    modelsUrl: function () {
        if (emulated) return "http://localhost:5000";
        const config = this.getEnvironmentConfig();
        return config.urls.models;
    },
    inferUrlV1: function (datasetType) {
        const config = this.getEnvironmentConfig();
        if (datasetType == "classification") {
            return config.inference.classification;
        } else if (datasetType == "instance-segmentation") {
            return config.inference.instanceSegmentation;
        } else if (datasetType == "semantic-segmentation") {
            return config.inference.semanticSegmentation;
        } else {
            return config.inference.objectDetection;
        }
    },
    inferUrl: function (datasetType) {
        const config = this.getEnvironmentConfig();
        return config.inference.serverless;
    },
    serverlessUrl: function () {
        const config = this.getEnvironmentConfig();
        return config.urls.serverless;
    },
    assetsCdnUrl: function () {
        const config = this.getEnvironmentConfig();
        return config.cdn.assets;
    },
    guestApiKey: function () {
        return process.env.GUEST_API_KEY;
    },
    deprecatedInferWorkflowUrl: function () {
        const config = this.getEnvironmentConfig();
        return `${config.urls.serverless}/infer/workflows`;
    },
    workflowUrl: function (workspaceUrl, workflowUrl) {
        const config = this.getEnvironmentConfig();
        return `${config.urls.serverless}/${workspaceUrl}/workflows/${workflowUrl}`;
    },
    dedicatedDeploymentsDomain: function () {
        const config = this.getEnvironmentConfig();
        return config.urls.dedicatedDeployments;
    },
    inferUsageCount: function () {
        return {
            usageCountsUrl: `${process.env.INFER_USAGE_COUNT_URL}?context=usage_counts`,
            cachedInferencesUrl: `${process.env.INFER_USAGE_COUNT_URL}?context=cached_inferences`
        };
    },
    inferUsageClear: function () {
        return {
            usageCountsUrl: `${process.env.INFER_USAGE_CLEAR_URL}?context=usage_counts`,
            cachedInferencesUrl: `${process.env.INFER_USAGE_CLEAR_URL}?context=cached_inferences`
        };
    },
    b64EnvToAscii: function (env_var) {
        if (env_var in process.env) {
            var buff = Buffer.from(process.env[env_var], "base64");
            return buff.toString("ascii");
        } else if (!emulated && !process.env.JEST_WORKER_ID) {
            console.error(
                "Environment variable not available:",
                env_var,
                ". OK during initialization of the cloud function, but not during runtime. For a one-off script, please look at the documentation for secrets management. https://roboflow.slab.com/topics/secrets-management-pl58tt6v"
            );
        }
        return "undefined";
    },
    awsKeys: function () {
        return module.exports.b64EnvToAscii("AWS_SECRET_JSON_B64");
    },
    browserbaseConfig: function () {
        return { apiKey: process.env.BROWSERBASE_API_KEY };
    },
    slackConfig: function () {
        return {
            token: process.env.SLACK_TOKEN,
            userAlertsToken: process.env.USER_ALERTS_SLACK_TOKEN
        };
    },
    superAdmins: function () {
        const config = this.getEnvironmentConfig();
        return config.superAdmins;
    },
    turnServerConfig: function () {
        const config = this.getEnvironmentConfig();
        return { secret: process.env.TURN_SERVER_SHARED_SECRET, urls: config.turnServer.urls };
    },
    roboflowApiAutomationsKey: function () {
        return module.exports.b64EnvToAscii("ROBOFLOW_API_AUTOMATIONS");
    },
    azureKey: function () {
        return module.exports.b64EnvToAscii("AZURE_COMPUTERVISION_USEAST_KEY");
    },
    openAIKey: function () {
        return module.exports.b64EnvToAscii("OPENAI_KEY");
    },
    googleVisionKey: function () {
        return module.exports.b64EnvToAscii("GOOGLE_VISION_KEY");
    },
    geminiApiKey: function () {
        return process.env.GEMINI_API_KEY || null;
    },
    anthropicApiKey: function () {
        return process.env.ANTHROPIC_API_KEY || null;
    },
    resendKey: function () {
        return module.exports.b64EnvToAscii("RESEND_KEY");
    },
    twilioAccountSid: function () {
        return process.env.TWILIO_ACCOUNT_SID || null;
    },
    twilioAuthToken: function () {
        return process.env.TWILIO_AUTH_TOKEN || null;
    },
    twilioPhoneNumber: function () {
        return "+15154003716";
    },
    demoUrl: function () {
        const config = this.getEnvironmentConfig();
        return config.urls.demo;
    },
    apolloConfig: function () {
        return { apiUrl: "https://api.apollo.io/v1/people/match", apiKey: process.env.APOLLO_KEY };
    },
    customerIoSiteId: function () {
        const config = this.getEnvironmentConfig();
        return config.customerIo.siteId;
    },
    customerIOConfig: function () {
        return {
            siteId: this.customerIoSiteId(),
            apiKey: process.env.CUSTOMER_IO_API_KEY,
            webhookSigningSecret: process.env.CUSTOMER_IO_WEBHOOK_SIGNING_KEY
        };
    },
    zoominfoConfig: function () {
        const clientId = module.exports.getEnvVar("ZOOMINFO_CLIENT_ID");
        const username = module.exports.getEnvVar("ZOOMINFO_USERNAME");
        const privateKey = module.exports.getEnvVar("ZOOMINFO_PRIVATE_KEY");
        const valueOrUndefined = (v) => (v === "not_set" ? undefined : v);
        return {
            baseUrl: "https://api.zoominfo.com",
            username: valueOrUndefined(username),
            privateKey: valueOrUndefined(privateKey),
            clientId: valueOrUndefined(clientId)
        };
    },
    apiUrl: function () {
        if (emulated) return "https://localapi.roboflow.one";
        const config = this.getEnvironmentConfig();
        return config.urls.api;
    },
    host: function (service) {
        const url = this.baseUrl(service);
        return url ? new URL(url).host : undefined;
    },
    baseUrl: function (service) {
        const config = this.getEnvironmentConfig();
        return config.urls[service];
    },
    isRoboflowDomain: function (host) {
        return allRoboflowDomains.some((domain) => host === domain || host.endsWith("." + domain));
    },
    workflowAssistantUrl: function () {
        // Firebase hosting buffers the response on staging/prod.
        // We need to call the cloud function directly to enable streaming responses.
        if (emulated) {
            return "https://localapp.roboflow.one";
        }
        const config = this.getEnvironmentConfig();
        return config.urls.workflowAssistant;
    },
    uploadDomain: function () {
        const config = this.getEnvironmentConfig();
        return config.urls.upload;
    },
    databaseURL: function () {
        return "https://" + name + ".firebaseio.com";
    },
    searchInvokerKeyFilename: function () {
        return module.exports.b64EnvToAscii("SEARCH_INVOKER_SECRET_JSON_B64");
    },
    stripeSecret: function () {
        return module.exports.b64EnvToAscii("STRIPE_KEY_SECRET_B64").replace("\n", "");
    },
    intercomAppId: function () {
        const config = this.getEnvironmentConfig();
        return config.intercom.appId;
    },
    intercomDevAccessToken: function () {
        return process.env.INTERCOM_DEV_ACCESS_TOKEN || "unset";
    },
    intercomInternalAccessToken: function () {
        return process.env.INTERCOM_INTERNAL_ACCESS_TOKEN || "unset";
    },
    supportDashboardApiKey: function () {
        // API key for authenticating support dashboard tool requests
        return process.env.SUPPORT_DASHBOARD_API_KEY || "unset";
    },
    intercomConnectorClientSecret: function () {
        return process.env.INTERCOM_CONNECTOR_CLIENT_SECRET || "unset";
    },
    intercomSharedSupportAccountId: function () {
        const config = this.getEnvironmentConfig();
        return config.intercom.sharedSupportAccountId;
    },
    intercomTeamIds: function () {
        const config = this.getEnvironmentConfig();
        return config.intercom.teamIds;
    },
    ipdataConfig: function () {
        return { apiUrl: "https://api.ipdata.co", apiKey: process.env.IPDATA_API_KEY };
    },
    calendly: function () {
        return { signingKey: process.env.CALENDLY_WEBHOOK_SIGNING_KEY };
    },
    firebaseConsoleUrl: function () {
        const config = this.getEnvironmentConfig();
        return config.firebase.consoleUrl;
    },
    adminUrl: function () {
        const config = this.getEnvironmentConfig();
        return config.urls.admin;
    },
    samEndpoint: function () {
        const config = this.getEnvironmentConfig();
        return config.inference.sam;
    },
    ritmEndpoint: function () {
        const config = this.getEnvironmentConfig();
        return config.inference.ritm;
    },
    autoLabelInferenceUrl: function () {
        const config = this.getEnvironmentConfig();
        return config.inference.autoLabel;
    },
    owlv2InferenceInternalEndpoint: function ({ forceStaging = false } = {}) {
        if (forceStaging) {
            return "https://inference-internal.crusoe.roboflow.one/owlv2/infer";
        }
        const config = this.getEnvironmentConfig();
        return config.inference.owlv2;
    },
    stagingInferenceInternalPassword: function () {
        return process.env.INFERENCE_INTERNAL_STAGING_PASSWORD;
    },
    inferenceInternalAuth: function () {
        return {
            username: process.env.INFERENCE_INTERNAL_USERNAME,
            password: process.env.INFERENCE_INTERNAL_PASSWORD
        };
    },
    inferenceInternalCookieName() {
        if (this.autoLabelInferenceUrl().includes("crusoe")) {
            return this.env() == "prod" ? "rf_inference_session_prd" : "rf_inference_session_stg";
        }
        return "GCLB";
    },
    gpuWorkflowUrl: function () {
        const config = this.getEnvironmentConfig();
        return config.inference.gpuWorkflow;
    },
    sheetsApiCredentials: function () {
        return JSON.parse(this.b64EnvToAscii("SHEETS_API_CREDENTIALS_JSON_B64"));
    },
    modelMonitoringServiceConfig: function () {
        const config = this.getEnvironmentConfig();
        return {
            apiUrl: config.modelMonitoring.apiUrl,
            sharedSecret: process.env.MODEL_MONITORING_SERVICE_SECRET,
            pubsubSecret: process.env.MODEL_MONITORING_PUBSUB_SECRET
        };
    },
    deviceMonitoringServiceConfig: function () {
        return {
            dbUrl: process.env.CLICKHOUSE_DEVICE_MONITORING_URL,
            keyId: process.env.DEVICE_MONITORING_SERVICE_KEY_ID,
            keySecret: process.env.DEVICE_MONITORING_SERVICE_KEY_SECRET,
            insertUrl: process.env.DEVICE_MONITORING_SERVICE_INSERT_URL,
            globalStatsUrl: process.env.DEVICE_MONITORING_SERVICE_GLOBAL_STATS_URL
        };
    },
    visionEventsServiceConfig: function () {
        return { dbUrl: process.env.CLICKHOUSE_VISION_EVENTS_URL };
    },
    turnstileConfig: function () {
        return { siteKey: "0x4AAAAAAAXTyo9_qTPTwG_G", secretKey: process.env.TURNSTILE_SECRET_KEY };
    },
    docsWorkspaceId: function () {
        const config = this.getEnvironmentConfig();
        return config.docsWorkspaceId;
    },
    searchConfig: function () {
        const indexUrl = process.env.SEARCH_CONFIG_INDEX_URL;
        const queryUrl = process.env.SEARCH_CONFIG_QUERY_URL;
        const searchConfig = {
            indexImageUrl: indexUrl + "/index_image",
            indexDatasetUrl: indexUrl + "/index_dataset",
            updateImageUrl: indexUrl + "/update_image",
            updateDatasetUrl: indexUrl + "/update_dataset",
            deleteImageUrl: indexUrl + "/delete_image",
            deleteDatasetUrl: indexUrl + "/delete_dataset",
            cleanupDeletedUrl: indexUrl + "/cleanup_deleted",
            queryImagesUrl: queryUrl + "/query-images",
            queryDatasetsUrl: queryUrl + "/query-datasets",
            roboqlQueryImagesUrl: queryUrl + "/roboql/images",
            workspaceTagsUrl: queryUrl + "/workspace-tags",
            workspaceMetadataKeysUrl: queryUrl + "/workspace-metadata-keys",
            workspaceMetadataValuesUrl: queryUrl + "/workspace-metadata-values",
            workspacePointInTime: queryUrl + "/workspace/point_in_time",
            imagesIndex: "images",
            imagesIndexPerceptionEncoder: "pe-images",
            datasetsIndex: "datasets",
            deviceLogsIndex: "rfdm-device-logs",
            elasticsearchUrl: process.env.ELASTICSEARCH_URL
        };

        if (process.env.SEARCH_SECRET_JSON_B64) {
            var searchSecrets = JSON.parse(module.exports.b64EnvToAscii("SEARCH_SECRET_JSON_B64"));
            for (var k in searchSecrets) {
                if (!searchConfig[k]) searchConfig[k] = searchSecrets[k];
            }
        }

        return searchConfig;
    },
    roboflowSharedSecret: function () {
        return process.env.ROBOFLOW_SHARED_SECRET;
    },
    modelEvalConfig: function () {
        let asyncCanaryRatio = parseFloat(process.env.MODEL_EVAL_ASYNC_CANARY_RATIO);
        if (Number.isNaN(asyncCanaryRatio)) {
            asyncCanaryRatio = 0.0;
        }
        const config = this.getEnvironmentConfig();
        return {
            modelEvalDockerUri: config.modelEval.dockerUri,
            gcpProjectId: config.gcpProjectId,
            gcpRegion: config.gcpRegion,
            roboflowApiUrl: config.modelEval.roboflowApiUrl,
            roboflowAppUrl: config.modelEval.roboflowAppUrl,
            objectDetectionInferenceEndpoint:
                env === "prod" && Math.random() <= asyncCanaryRatio
                    ? config.modelEval.asyncInferenceEndpoint
                    : config.modelEval.objectDetectionInferenceEndpoint,
            roboflowSharedSecret: process.env.ROBOFLOW_SHARED_SECRET
        };
    },
    salesforceConfig: function () {
        return {
            OrgIds: ["00D8c000002JHM3EAO", "00D8c000002JHM3"],
            username: "sfdc-admin@roboflow.com",
            grant_type: "password",
            client_id: process.env.SFDC_CLIENT_ID,
            client_secret: process.env.SFDC_CLIENT_SECRET,
            password: process.env.SFDC_ADMIN_PASSWORD,
            redirectUri: "https://login.salesforce.com",
            serverUrl: "https://roboflow1.my.salesforce.com",
            serviceBaseUrl: "https://roboflow1.my.salesforce.com/services"
        };
    },
    firebaseConfig: function () {
        const config = this.getEnvironmentConfig();
        return config.firebase;
    },
    cdnHost: function () {
        const config = this.getEnvironmentConfig();
        return config.cdn.source;
    },
    trainBucketHost: function () {
        const config = this.getEnvironmentConfig();
        return config.cdn.repo;
    },
    userContentCdnHost: function () {
        const config = this.getEnvironmentConfig();
        return config.cdn.userContent;
    },
    bucket: function (alias) {
        const config = this.getEnvironmentConfig();
        const bucket = config.buckets[alias];
        if (!bucket) {
            throw new Error(`Unknown bucket alias: "${alias}". Add it to the environment config.`);
        }
        return bucket;
    },
    sampleDataset: function () {
        const config = this.getEnvironmentConfig();
        return config.sampleDataset;
    },
    largeWorkspaces: function () {
        const config = this.getEnvironmentConfig();
        return config.largeWorkspaces;
    },
    isTestAccount: function (uid) {
        return ["M5cW8kOMUTYeQSx7gzruDys3t6j1", "BTbkIboA2XeK0nawHIY9gjL7aPe2"].includes(uid);
    },
    supportTeam: function () {
        const config = this.getEnvironmentConfig();
        return {
            id: config.supportTeam.id,
            name: "Roboflow Support",
            color: "#5c6ac4",
            icon: "fad fa-user-headset"
        };
    },
    billingUsageServiceConfig: function () {
        const config = this.getEnvironmentConfig();
        const redisHost = emulated
            ? process.env.EMULATED_REDIS_HOST_PORT || "localhost:6379"
            : config.redis.billing;
        return { redisHost };
    },
    redisConfig: function () {
        const config = this.getEnvironmentConfig();
        return emulated
            ? process.env.EMULATED_REDIS_HOST_PORT || "localhost:6379"
            : config.redis.cache;
    },
    redisFlushConfig: function () {
        if (emulated) {
            return { host: "localhost", port: 6379 };
        }
        const config = this.getEnvironmentConfig();
        return config.redis.flush;
    },
    gcpRegion: function () {
        const config = this.getEnvironmentConfig();
        return config.gcpRegion;
    },
    vpcConnector: function () {
        const config = this.getEnvironmentConfig();
        return config.vpcConnector;
    },
    vpcConnectorCloudRun: function () {
        return "cloudrun-connector";
    },
    supportUser: function () {
        const config = this.getEnvironmentConfig();
        return config.supportUser;
    },
    stripeSigningSecret: function () {
        return process.env.STRIPE_SIGNING_SECRET || "not_set";
    },
    stripe: function () {
        const config = this.getEnvironmentConfig();
        const stripeConfig = config.stripe;
        return {
            publishable_key: stripeConfig.publishableKey,
            starter_plan: stripeConfig.starterPlan,
            basic_plan: stripeConfig.basicPlan,
            core_plan: stripeConfig.corePlan,
            growth_plan: stripeConfig.growthPlan,
            auto_label: stripeConfig.autoLabel,
            flex_usage: stripeConfig.flexUsage
        };
    },
    stripeProduct: function (productName) {
        const config = this.getEnvironmentConfig();
        switch (productName) {
            case "source_image":
                return config.stripe.products.sourceImage;
            case "generated_image":
                return config.stripe.products.generatedImage;
        }
    },
    stripeCoupons: function () {
        const config = this.getEnvironmentConfig();
        return config.stripe.coupons;
    },
    bigQueryDataset: function () {
        const config = this.getEnvironmentConfig();
        return config.bigQuery.dataset;
    },
    bigQueryWorkspace: function () {
        const config = this.getEnvironmentConfig();
        return config.bigQuery.workspace;
    },
    bigQueryUniverseDatasetStatsTable: function () {
        const config = this.getEnvironmentConfig();
        return config.bigQuery.universeDatasetStats;
    },
    clickhouseDeviceMonitoringService: function () {
        const config = this.getEnvironmentConfig();
        return config.clickhouseDeviceMonitoring.serviceId;
    },
    projectId: function () {
        return name;
    },
    segment: function () {
        if (env === "prod") {
            return { internalScriptWriteKey: process.env.SEGMENT_INTERNAL_SCRIPT_WRITE_KEY };
        } else {
            return { internalScriptWriteKey: "ELfHvGRZoIE3q2shXlWQmwJoycPMhGI2" };
        }
    },
    frontendSegmentWriteKey: function () {
        const config = this.getEnvironmentConfig();
        return config.segment.frontendWriteKey;
    },
    posthogConfig: function () {
        const config = this.getEnvironmentConfig();
        return {
            apiKey: config.posthog.apiKey,
            apiHost: "https://us.i.posthog.com",
            enabled: !emulated
        };
    },
    reddit: function () {
        const config = this.getEnvironmentConfig();
        return {
            appId: config.reddit.appId,
            eventAccessToken: process.env.REDDIT_EVENT_ACCESS_TOKEN
        };
    },
    allBaseRoles: function () {
        return ["owner", "labeler", "reviewer"];
    },
    internalAuthTokens: function () {
        const usageOverageToken = process.env.USAGE_OVERAGE_ENDPOINT_TOKEN;
        return { usageOverageToken };
    },
    RestrictedReason: {
        NoPaymentMethod: "no_payment_method",
        PastDue: "past_due",
        Churned: "churned"
    },
    DEFAULT_USAGE: {
        plan: "free",
        billing: false,
        pro: false,
        restricted: false,

        limit: {
            sources: 1000,
            transforms: 5000,
            collaborators: 5,
            projects: 100,
            variantsPerImage: 3,
            soft: false
        },

        train: { quota: 0, used: 0 },

        oak: { limit: 5, mau: 0 },

        tfjs: { limit: 1000, mau: 0 },

        coreml: { limit: 1, mau: 0 },

        soft: false,
        inference: {
            soft: false,
            quota: 1000,
            used: 0,
            billing_period: "monthly",
            last_billed_on: null,
            replenish_after_billing: true
        },

        threshold: 100,
        rates: { sources: 1000, transforms: 200 },

        total: 0,
        images: { sources: 0, transforms: 0 },

        features: {
            creditSystem: false,
            allowPrivateProjects: true,
            apiUpload: true,
            emailUpload: true,
            videoProcessing: false,
            healthCheck: true,
            outsourcedAnnotations: false,
            advancedTransforms: false,
            exportVersion: false,
            cloudMlIntegrations: false,
            tfjsInBrowser: "dev_only",
            edgeInference: "forbidden",
            embedInMobileApps: false,
            offlineMode: false,
            vpcDeployment: false,
            supportLevel: "None",
            annotationReview: false,
            workspaceInsights: false,
            classAttributes: false,
            advancedLabelAssist: false,
            deviceMonitoring: false,
            rbac: false,
            highComplexitySmartPoly: false,
            modelEvaluation: false,
            sessionRecording: false,
            refreshAnnotationsButton: false,
            unlimitedTimeDedicatedDeployments: false,
            billSelfHostedDeployments: false
        },

        workspace: { isSetup: true, team: true, plan: "legacy" },

        ubp: { includedCredits: 15, creditCap: 15, pricePerCredit: 2 },

        maxCreditsPerStream: null,

        acceptedCancelOffer: false
    },
    getInferenceUsageConfig: function () {
        return {
            shared_aws_secret: process.env.INFERENCE_USAGE_SHARED_AWS_SECRET,
            roboflow_internal_secret: process.env.ROBOFLOW_INTERNAL_SERVICE_SECRET
        };
    },
    getInternalServiceIPs: function () {
        const config = this.getEnvironmentConfig();
        return config.internalServiceIPs;
    },
    getEnvVar: function (env_name) {
        if (process.env[env_name]) {
            return process.env[env_name];
        } else {
            if (!process.env.JEST_WORKER_ID) {
                console.error(env_name, " is not set, returning dummy value of not_set");
            }
            return "not_set";
        }
    },
    fbExportBucket: function () {
        const config = this.getEnvironmentConfig();
        return config.buckets["fb-export"];
    },
    envDomain: function () {
        const config = this.getEnvironmentConfig();
        return config.urlDomain;
    },
    trainClusters: function () {
        const config = this.getEnvironmentConfig();
        // Add dynamic kubeconfig content from env var
        const clusters = { ...config.trainClusters };
        if (clusters["crusoe-train"]) {
            clusters["crusoe-train"] = {
                ...clusters["crusoe-train"],
                kubeconfigContent: process.env.CRUSOE_KUBECONFIG
            };
        }
        return clusters;
    },
    trainClusterDefault: function () {
        return "goog-us-central1";
    },
    spotTrainCanaryFractionSmall: function () {
        return process.env.SPOT_TRAIN_CANARY_FRACTION_SMALL || 0.0;
    },
    spotTrainCanaryFractionMedium: function () {
        return process.env.SPOT_TRAIN_CANARY_FRACTION_MEDIUM || 0.0;
    },
    spotTrainCanaryFractionLarge: function () {
        return process.env.SPOT_TRAIN_CANARY_FRACTION_LARGE || 0.0;
    },
    videoBatchInferenceEndpoint: function () {
        return process.env.VIDEO_BATCH_INFERENCE_ENDPOINT;
    },
    videoBatchInferenceKey: function () {
        return process.env.VIDEO_API_KEY;
    },
    autodistillBucketName: function () {
        const config = this.getEnvironmentConfig();
        return config.buckets["autodistill"];
    },
    firebaseAppCheckSiteKey: function () {
        const config = this.getEnvironmentConfig();
        return config.firebase.appCheckSiteKey;
    },
    yolonasCocoModels: function () {
        const config = this.getEnvironmentConfig();
        return config.yolonasCocoModels;
    },

    sessionTrackerConnection: function () {
        const config = this.getEnvironmentConfig();
        return config.sessionTracker;
    },

    sentryDsn: function () {
        return "https://82998ea7043238f53974072fca79f12d@o4510150417383424.ingest.us.sentry.io/4510150426558464";
    },

    getImageSuggestionsDataset: function () {
        const config = this.getEnvironmentConfig();
        return config.imageSuggestionsDataset;
    },
    getCocoModel() {
        const config = this.getEnvironmentConfig();
        return config.cocoModel;
    },

    getAssumeIdentityServiceAccessToken: function () {
        return process.env.ASSUME_IDENTITY_SERVICE_ACCESS_TOKEN;
    },

    getExternalUsageReporterAccessToken: function () {
        return process.env.EXTERNAL_USAGE_REPORTER_ACCESS_TOKEN;
    },

    spannerConfig() {
        const config = this.getEnvironmentConfig();
        return {
            projectId: this.name(),
            instanceId: config.spanner.instanceId,
            databaseId: "roboflow"
        };
    },

    getDataStagingBucket: function () {
        const config = this.getEnvironmentConfig();
        return config.buckets["data-staging"];
    },

    getBatchProcessingPubSubTopic: function () {
        const config = this.getEnvironmentConfig();
        return config.pubsub.batchProcessing;
    },

    getDataStagingServiceSecret: function () {
        return process.env.DATA_STAGING_SERVICE_SECRET;
    },

    getBatchProcessingServiceSecret: function () {
        return process.env.BATCH_PROCESSING_SERVICE_SECRET;
    },

    getExperimentalFeaturesServiceSecret: function () {
        return process.env.EXPERIMENTAL_FEATURES_SERVICE_SECRET;
    },

    getWorkflowsServiceUrl: function () {
        const config = this.getEnvironmentConfig();
        return config.urls.serverless;
    },

    getBatchProcessingBucket: function () {
        const config = this.getEnvironmentConfig();
        return config.buckets["batch-processing"];
    },

    getDataStagingPubSubTopic: function () {
        const config = this.getEnvironmentConfig();
        return config.pubsub.dataStaging;
    },

    getModelsServiceInternalSecret: function () {
        return process.env.MODELS_SERVICE_INTERNAL_SECRET;
    },

    getModelsServiceInternalSecretReference: function () {
        const config = this.getEnvironmentConfig();
        return config.modelsServiceSecretRef;
    },

    getBucketMirrorConfig: function () {
        const config = this.getEnvironmentConfig();
        const defaults = config.bucketMirror;

        const awsAccountId = process.env.BUCKET_SYNC_AWS_ACCOUNT_ID || defaults.awsAccountId;
        const gcpAccessRoleArn =
            process.env.BUCKET_SYNC_GCP_ACCESS_ROLE_ARN || defaults.gcpAccessRoleArn;
        const adminApiRoleArn =
            process.env.BUCKET_SYNC_ADMIN_API_ROLE_ARN || defaults.adminApiRoleArn;
        const apiEndpoint = process.env.BUCKET_SYNC_API_ENDPOINT || defaults.apiEndpoint;
        const s3VpceId = process.env.BUCKET_SYNC_S3_VPCE_ID || defaults.s3VpceId;
        const s3VpceDns = process.env.BUCKET_SYNC_S3_VPCE_DNS || defaults.s3VpceDns;

        return {
            awsAccountId,
            AWSSecureTunnelGCPServiceAccount: defaults.gcpServiceAccount,
            AWSSecureTunnelS3Endpoint: s3VpceDns,
            AWSWebIdentity: { audience: defaults.audience, roleArn: gcpAccessRoleArn },
            adminApiRoleArn,
            roleProvisioningApiEndpoint: apiEndpoint,
            roleProvisioningApiVpcEndpoint:
                process.env.BUCKET_SYNC_API_VPC_ENDPOINT || defaults.apiVpcEndpoint,
            s3VpcEndpoints: s3VpceId
                ? { "us-east-1": { endpointId: s3VpceId, dnsName: s3VpceDns } }
                : {}
        };
    },

    gcpTrainBucketName: function () {
        const config = this.getEnvironmentConfig();
        return config.buckets.train;
    },

    gcpCacheBucketName: function () {
        const config = this.getEnvironmentConfig();
        return config.buckets.cache;
    },

    gcpResumeBucketName: function () {
        const config = this.getEnvironmentConfig();
        return config.buckets["train-resume"];
    },

    gcpCoreModelsBucketName: function () {
        const config = this.getEnvironmentConfig();
        return config.buckets["core-models"];
    },

    gcpTRTCOmpilationBucket: function () {
        const config = this.getEnvironmentConfig();
        return config.buckets["trt-compilation"];
    },

    r2CoreModelsBucketName: function () {
        const config = this.getEnvironmentConfig();
        return config.r2.coreModelsCache;
    },

    r2Endpoint() {
        const config = this.getEnvironmentConfig();
        return config.r2.endpoint;
    },

    /**
     * Get the environment configuration for the current project.
     * Returns configuration values from the JS config files in packages/shared/environments/
     *
     * @returns {Object} Environment configuration object
     */
    getEnvironmentConfig: function () {
        const config = environmentConfigs[name];
        if (!config) {
            throw new Error(`No environment config found for project: ${name}`);
        }
        return config;
    }
};

module.exports = project;
